/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useContext, useState } from 'react';
import { BiCommentCheck } from 'react-icons/bi';
import Button from '../../@base/Button';
import FlowContext from '../../../context/FlowContext';
import Scrim from '../../@base/Scrim';
import Modal from '../../@base/Modal';
import DialogNotification from '../../DialogNotification/DialogNotification';

/** Componente que aprensenta Caixa de dialogo de confirmação de publicação */
const PublishConfirmation = (props) => (
  <Scrim classes="is-foco">
    <Modal
      title="Confirmação da publicação"
      content={(
        <>
          <p>
            Ao confirmar a operação, esse fluxo será publicado
            no ambiente de desenvolvimento do chatbot.
            <br />
            Essa operaçao pode demorar alguns minutos.
          </p>
          <p style={{ fontWeight: 'var(--font-weight-semi-bold)' }}>
            Você confirma a publicação em desenvolvimento?
          </p>

        </>
      )}
      buttons={(
        <>
          <Button primary small classes="mr-1" onClick={props.yesAction}>
            <small>Sim</small>
          </Button>
          <Button primary small onClick={props.noAction}>
            <small>Não</small>
          </Button>
        </>
  )}
    />
  </Scrim>
);

/**
 * Componente que retorna caixa de dialogo notificação de falha na publicação
 */
const PublishFailedNotification = ({ okAction }) => (
  <DialogNotification
    okAction={okAction}
    title="Não foi possível publicar o fluxo"
    content={(
      <p>
        Aguarde alguns instantes e tente novamente.
        <br />
        Se o problema persistir acione o
        <a target="_blank" href={`https://${window.location.hostname}/docs/contato/`} rel="noreferrer"> suporte do Serprobots.</a>
      </p>
)}
  />
);

/**
 * Componente que exibi
 * botão de publicação e visualização do teste do chatbot
 */
const PublishButton = () => {
  const flowContext = useContext(FlowContext);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const [isPublishFailed, setIsPublishFailed] = useState(false);

  const failurePublishCallback = () => {
    setIsPublishing(false);
    setIsPublishFailed(true);
  };

  const successPublishCallback = () => {
    setIsPublishing(false);
    setIsPublishFailed(false);
  };

  const publish = () => {
    setShowConfirmation(false);
    setIsPublishing(true);
    flowContext.publish(successPublishCallback, failurePublishCallback);
  };

  const tryButtonHandler = () => {
    const mnemonic = flowContext.lastPublication.chatbotMnemonic;
    const { origin } = window.location;
    const urlChatBot = `${origin}/curadoria/teste.html?origin=&mnemonic=${mnemonic}`;
    window.open(urlChatBot, '_blank');
  };

  return (
    <>
      {showConfirmation && (
      <PublishConfirmation
        yesAction={() => publish()}
        noAction={() => setShowConfirmation(false)}
      />
      )}

      {isPublishFailed && (
      <PublishFailedNotification
        okAction={() => setIsPublishFailed(false)}
      />
      )}

      <li className="divider ">
        <Button
          small
          primary
          onClick={() => setShowConfirmation(true)}
          disabled={isPublishing}
        >
          <small>Publicar</small>
        </Button>
        { isPublishing && (
          <Button
            classes="ml-1"
            small
            circle
            title="Publicando..."
          >
            <i className="fas fa-sync fa-spin" aria-hidden="true" />
          </Button>
        ) }

        { (!isPublishing && flowContext.lastPublication) && (
        <Button
          classes="ml-1"
          small
          circle
          title="Experimente o chatbot"
          onClick={tryButtonHandler}
        >
          <BiCommentCheck size="1.3em" />
        </Button>
        )}

      </li>
    </>
  );
};

export default PublishButton;
